import { Injectable } from '@angular/core';
import { ENV_Settings } from '../../shared/utils.utility';
import { FunctionsService } from '../functions.service';
import { ApiService } from 'src/app/api.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserRefreshToken } from 'src/app/models/userRefreshTokenModel';
import { Observable } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class TokenService {
  role: string;
  constructor(
    private apiService: ApiService,
    private functionsService: FunctionsService,
    private permission: NgxPermissionsService,
  ) {}

    getAccessToken(): Observable<any> {
    let urt = new UserRefreshToken();
    urt.accessToken = null;
    urt.refreshToken = null;
    urt.portal = true;
    return this.apiService.updateRefreshToken(urt);
  }

    async setInfo(accessTokenRes){
    this.role = localStorage.getItem('role');
    if(this.role=="User"){
        this.functionsService.signOut();
    }

    this.permission.flushPermissions();
    this.permission.addPermission([this.role]);
    if(await this.functionsService.isExpired()){ 
        this.permission.addPermission("Expired");
    }
  }
}
